import { Switch, Route } from 'react-router-dom';
import AdminDashboardPage from './admin';
import DefaultDashboardPage from './default';

const Dashboard = () => {
  return (
    <Switch>
      <Route exact path='/admin' component={AdminDashboardPage} />
      <Route exact path='/' component={DefaultDashboardPage} />
    </Switch>
  );
};

export default Dashboard;
